/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-11 10:45:42
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-02-11 16:12:51
 * @name: 用户存储
 * @Description: 用户存储
 * @FilePath: \preSaleNafterSaleInside\project\src\storage\user.storage.js
 * @Author: desktop
 */
import cookie from "./cookie";
class userStorage extends cookie {
  constructor() {
    super();
    this.token = this.getToken();
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取token
   * @return {String} token
   */
  getToken() {
    return super.get('token');
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 设置token
   */
  setToken(token) {
    super.set('token', token);
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 移除token
   */
  removeToken() {
    super.remove('token');
  }
}
export default userStorage;